<template>
  <div class="dashboard">
    <h2>Interactions</h2>
    <interactions-grid
      :initial-interactions="initialInteractions"
      :initial-per-page="initialPerPage"
      :initial-current-page="initialCurrentPage"
      :message-root-url="messageRootUrl"
      :api-root-url="apiRootUrl"
      :user-profile-url="userProfileUrl"
      :view-interaction-url="viewInteractionUrl"
      :interaction-tags="interactionTags"
    ></interactions-grid>
  </div>
</template>

<script>
import InteractionsGrid from "@/components/dashboard/InteractionsGrid";

export default {
  name: "Dashboard",
  components: {
    InteractionsGrid
  },

  data() {
    return {};
  },
  created() {
    this.perPage = this.initialPerPage;
    this.currentPage = this.initialCurrentPage;
    // set the table to expect values so that it makes an initial request
    this.interactionsTotal = this.perPage;
  },
  props: {
    initialInteractions: {
      type: Object,
      default: () => {}
    },
    apiRootUrl: {
      type: String,
      required: true
    },
    messageRootUrl: {
      type: String,
      required: true
    },
    userProfileUrl: {
      type: String,
      required: true
    },
    viewInteractionUrl: {
      type: String,
      required: true
    },
    interactionTags: {
      type: Array,
      required: true,
      validator: value => Array.isArray(value) && value.length > 0
    },
    initialCurrentPage: {
      type: Number,
      default: 1
    },
    initialPerPage: {
      type: Number,
      default: 5
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
